import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { Box, alpha, lighten, useTheme, styled } from '@mui/material';

import Sidebar from './Sidebar';
import Header from './Header';
import AlertBox from '../../components/AlertBox';
import { RootState, useAppSelector } from '../../state/store';
import { getLoading } from '../../state/user/userSlice';
import ProgressLoader from '../../components/Loader';


const PageContentWrapper = styled(Box)(
  ({ theme }) => `
        padding-left: ${theme.sidebar.width};
        width: 100%;
        @media (max-width: 1279px) {
          padding-left: 0;
        }
`
);

interface SidebarLayoutProps {
  children?: ReactNode;
}

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const theme = useTheme();
  let { show, message, type } = useSelector((state: RootState) => state.utils) || {};
  const authLoading = useAppSelector(getLoading('auth'))

  return (
    <Box
      sx={{
        flex: 1,
        height: '100%',
        '.MuiPageTitle-wrapper': {
          background:
            theme.palette.mode === 'dark'
              ? theme.colors.alpha.trueWhite[5]
              : theme.colors.alpha.white[50],
          marginBottom: `${theme.spacing(4)}`,
          boxShadow:
            theme.palette.mode === 'dark'
              ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
              : `0px 2px 4px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}, 0px 5px 12px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.05
              )}`
        }
      }}
    >
      <AlertBox type={type} showAlert={show} message={message} />
      <Sidebar />
      <PageContentWrapper>
        <Header />
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            pt: `${theme.header.height}`,
          }}
        >
          <Box display="block">
            <ProgressLoader loading={authLoading} />
            <Outlet />
          </Box>
        </Box>
      </PageContentWrapper>
    </Box>
  );
};

export default SidebarLayout;
